// theme/ThemeProvider.jsx
import React, { createContext, useContext, useLayoutEffect, useMemo, useState } from "react";
import { Base, Halloween} from "../theme/theme.js";

const REGISTRY = {
    base: Base,
    halloween: Halloween,
};

const Ctx = createContext(null);

export function useTheme() {
    const v = useContext(Ctx);
    if (!v) throw new Error("useTheme must be inside ThemeProvider");
    return v;
}

function applyCssVars(theme) {
    const r = document.documentElement;
    r.dataset.theme = theme.name;
    r.style.setProperty("--color-text", theme.colors.text);
    r.style.setProperty("--color-button-special-bg", theme.colors.buttonSpecialBg);
    r.style.setProperty("--color-login-form-bg", theme.colors.loginFormBg);
    r.style.setProperty("--font-size-button", theme.fonts.buttonFontSize);
    r.style.setProperty("--font-size-label", theme.fonts.loginLabelFontSize);
    const src = theme.images?.backgroundImg || "";
    r.style.setProperty(
        "--login-bg-img",
        src ? `url("${src}")` : "none"
    );
    r.style.setProperty("--font-base", theme.fonts.base);
    r.style.setProperty("--font-festive", theme.fonts.festive || theme.fonts.base);
}

export function ThemeProvider({ initial = "base", children }) {
    const [name, setName] = useState(initial);
    const theme = useMemo(() => REGISTRY[name], [name]);

    useLayoutEffect(() => { applyCssVars(theme); }, [theme]);

    return (
        <Ctx.Provider value={{ theme, setThemeName: setName }}>
            {children}
        </Ctx.Provider>
    );
}
